import { useTranslations } from '@altermaind/core/i18n';
import { Card, Typography } from '@altermaind/web/ui';
import { Charts } from '@/_shared/components/Charts';
import { useBreakingPoints } from '@/_shared/hooks/useBreakpoint';
import { getSurveyCampaignByIdResponsesResultsStatsCall } from '../../state';

export const DistributionBox = () => {
  const t = useTranslations('surveys.details.stats.tabOrganization.distributionBox');
  const { organizationStats } = getSurveyCampaignByIdResponsesResultsStatsCall.hook();

  const { isDesktop } = useBreakingPoints();

  return (
    <Card mt='s'>
      <Typography variant='h3' mb='xs'>
        {t('title')}
      </Typography>
      <Typography variant='p3/light' mb='l'>
        {t('description')}
      </Typography>
      <Charts.StackedBarChartComponent
        total={organizationStats?.totalCompletedSurveys || 0}
        data={organizationStats?.metricsScore || []}
        defaultItemsSize={isDesktop ? 6 : 2}
      />
    </Card>
  );
};
